class SymbolCounterComponent {
  constructor($el) {
    if (!$el.length) return
    this.$counters = $el

    this.initCounter()
  }

  initCounter() {
    this.$counters.each((_, root) => {
      const $root = $(root)
      const maxLength = $(root).data('maxLength') || 0
      const showOnlyNumber = !!$(root).data('onlyNumber')

      const updateCounter = () => {
        const count = $root.find('input, textarea').val().length

        const $counterValue = $root.find('.js-counter-value')
        if (showOnlyNumber) {
          $counterValue.text(count)
        } else {
          $counterValue.text(`${count} character${count !== 1 ? 's' : ''}`)
        }

        const isTooLong = maxLength && count > maxLength
        const isAlmostTooLong = maxLength && count > 0.8 * maxLength

        if (isTooLong) {
          $counterValue.css('color', '#f22322')
        } else if (isAlmostTooLong) {
          $counterValue.css('color', '#e58f0e')
        } else {
          $counterValue.css('color', '')
        }
      }

      $root
        .find('input, textarea')
        .on('propertychange change click keyup input paste', updateCounter)

      updateCounter()
    })
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new SymbolCounterComponent($('.js-counter'))
})
